/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { ErrorType } from "../../apix-handler";
import type {
  BadRequestResponse,
  EntitySnapshotResponse,
  EntityType,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `draft`
 * @summary Get version history for an entity (list of snapshots, newest first)
 */
export const entitySnapshotsByEntityTypeAndEntityExternalIdGetV2 = (
  entityType: EntityType,
  entityExternalId: string,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<EntitySnapshotResponse[]>(
    {
      url: `/apix/v2/EntitySnapshots/${entityType}/${entityExternalId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getEntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryKey = (
  entityType?: EntityType,
  entityExternalId?: string,
) => {
  return [
    `/apix/v2/EntitySnapshots/${entityType}/${entityExternalId}`,
  ] as const;
};

export const getEntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
    >,
    TError = ErrorType<BadRequestResponse>,
  >(
    entityType: EntityType,
    entityExternalId: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getEntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryKey(
        entityType,
        entityExternalId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
      >
    > = ({ signal }) =>
      entitySnapshotsByEntityTypeAndEntityExternalIdGetV2(
        entityType,
        entityExternalId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(entityType && entityExternalId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type EntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
    >
  >;
export type EntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryError =
  ErrorType<BadRequestResponse>;

/**
 * @summary Get version history for an entity (list of snapshots, newest first)
 */

export function useEntitySnapshotsByEntityTypeAndEntityExternalIdGetV2<
  TData = Awaited<
    ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
  >,
  TError = ErrorType<BadRequestResponse>,
>(
  entityType: EntityType,
  entityExternalId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof entitySnapshotsByEntityTypeAndEntityExternalIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getEntitySnapshotsByEntityTypeAndEntityExternalIdGetV2QueryOptions(
      entityType,
      entityExternalId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
